module.exports = __webpack_public_path__ + "img/bb.89161f14.svg";